import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { ModalFormComponent } from '@shared/components/modal/modal-form/modal-form.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { IListboxRegion } from '@shared/components/form/input-listbox-region/input-listbox-region.interface';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { RetailerService } from '@pages/retailer/retailer.service';

@Component({
  selector: 'app-input-listbox-cakupan-wilayah',
  templateUrl: './input-listbox-cakupan-wilayah.component.html',
  styleUrls: ['./input-listbox-cakupan-wilayah.component.scss'],
})
export class InputListboxCakupanWilayahComponent implements OnInit, OnDestroy {
  @Input() chipsListData: IListboxRegion[];
  @Output() selectionOutput = new EventEmitter<IListboxRegion[]>();

  private unsubscribe: Subscription[] = [];

  listItemsBank = [] as IListboxRegion[];
  listSelectedItems: IListboxRegion[] = [];

  searchKeyword = '';
  filterMeta = { count: 0 };
  loading = new BehaviorSubject(false);

  // config:
  ctaLabelAdd = 'Tambahkan';
  label = 'Cakupan Wilayah';
  dialogTitle = 'Pilih Cakupan';
  labelOpenModalForm = 'Tambah Cakupan Wilayah';
  required = true;

  param = {
    size: 20,
    string_filter: undefined,
    page: 0,
  };

  macMitraList$ = this.retailerService.macMitraList$;
  fetchMitraHasError = new BehaviorSubject(false);
  fetchMitraResp = new BehaviorSubject('');

  @ViewChild('modalForm') modalFormComponent: ModalFormComponent;
  modalFormConfig: ModalConfig = {
    modalTitle: this.dialogTitle,
    disableCloseButton: () => this.loading.value,
  };

  @ViewChild('selectListContainer') selectListContainer: ElementRef;
  @ViewChild('anchor') anchor: HTMLElement;

  constructor( private retailerService: RetailerService, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {}

  handleOpenDialog() {
    this.modalFormComponent.open();
    this.searchKeyword = '';
    if (!this.listItemsBank.length) {
      return this.getListBoxData();
    }
  }

  getData() {
    const { id } = this.activatedRoute.snapshot.queryParams;
    return this.retailerService.getMACAreaWithParam(id, this.param);
  }

  getListBoxData() {
    this.loading.next(true);
    const _dataSubs = this.getData().subscribe((resp) => {
      if (!resp) {
        return;
      }

      const { data, total_data, current_page, has_next } = resp;
      this.param = {
        ...this.param,
        page: current_page + 1,
        size: total_data,
      };

      // no more page to load and list bank is already filled
      if (!has_next && this.listItemsBank.length) return this.loading.next(false);

      data.map((item) => (item.selected = false));
      this.listItemsBank = this.listItemsBank.concat(data);

      // remove any duplicated
      this.listItemsBank = [...new Map(this.listItemsBank.map((item) => [item.id, item])).values()];

      if (this.listSelectedItems.length) {
        this.listItemsBank.map((item) => {
          return this.listSelectedItems.map((s) => {
            if (s.id === item.id) return (item.selected = true);
          });
        });
      }

      // todo note:
      // need to remove item that already in list bank
      // but keep the selected item in list
      // might be better to filter out before concatenating

      this.loading.next(false);
    });

    this.unsubscribe.push(_dataSubs);
  }

  handleChangeSelection() {
    this.listSelectedItems = this.listItemsBank.filter((item) => item.selected);
    this.selectionOutput.emit(this.listSelectedItems);
    this.resetMitraList();
  }

  handleAddChips() {
    // fetch mitra,
    // if success fetching then close the modal
    // toggle show selected chips-legacy on form
    this.fetchMitraHasError.next(false);
    this.loading.next(true);
    this.getMitra();
  }

  handleOutputChips(items: IListboxRegion[]) {
    this.listSelectedItems = items;
    this.selectionOutput.emit(this.listSelectedItems);
    this.resetMitraList();
  }

  isIntersecting(endOfList: boolean) {
    if (endOfList) return this.loadMoreData();
  }

  loadMoreData = () => {
    if (this.loading.value) return;
    this.getListBoxData();
  };

  getMitra() {
    const _payloadIds = this.mapToPayloadDistrictIds(this.listSelectedItems);
    const _mitraListSubs = this.retailerService.getMitraList(_payloadIds).subscribe((resp) => {
      if (!resp) return;

      if (resp.success) {
        const { data } = resp;
        this.retailerService.MacMitraList = data;
        this.modalFormComponent.close().then(() => this.toggleShowSelectedList());
      }

      if (resp.errors) {
        const { errors } = resp;
        this.fetchMitraHasError.next(true);
        this.fetchMitraResp.next(errors[0]?.message);
      }

      setTimeout(() => this.loading.next(false), 250);
    });

    this.unsubscribe.push(_mitraListSubs);
  }

  mapToPayloadDistrictIds(selectedItems: IListboxRegion[] = []) {
    const _ids: { district_id: string[] } = { district_id: [] };
    selectedItems.map((item) => _ids.district_id.push(item.id));
    return _ids;
  }

  resetMitraList() {
    if (!this.listSelectedItems.length) {
      this.retailerService.MacMitraList = [];
    }
  }

  handleChangeKeyword(e: any) {
    if (e.length < 3) return (this.param.string_filter = undefined);
    this.param.page = 0;
    this.param.string_filter = e;
    this.getListBoxData();
  }

  toggleShowSelectedList = () => (this.chipsListData = this.listSelectedItems);

  hasMitraList = () => this.retailerService.MacMitraList.length > 0;

  renderMitraList = (selectedItems: string[]) => this.retailerService.renderMitraList(selectedItems);

  isNoSearchResults = () => !this.loading.value && this.searchKeyword && this.filterMeta.count === 0;

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
